<div [formGroup]="generalFormGroup">
  <div class="px-2">
    <div class="form-row row">
      <label for="name" class="col-2 control-label required">{{'i18n.domain.administration.tariff-details.general-tab.name' | translate}}</label>
      <div class="col-10 col-lg-4 align-items-center">
          <input type="text"
                 id="name"
                 name="name"
                 formControlName="name"
                 class="form-control"
                 autocomplete="off">
          <app-error-messages [control]="generalFormGroup.controls.name"></app-error-messages>
      </div>
    </div>
    <div class="form-row row">
      <label for="description" class="col-2 control-label multiple-line-control">{{'i18n.domain.administration.tariff-details.general-tab.description' | translate}}</label>
      <div class="col-10">
      <textarea id="description"
                name="description"
                formControlName="description"
                rows="3"
                autocomplete="off"
                class="form-control"></textarea>
        <app-error-messages [control]="generalFormGroup.controls.description"></app-error-messages>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-2 control-label">{{'i18n.domain.administration.tariff-details.general-tab.place-of-residence' | translate}}:</label>
      <div class="col-10 col-xl-4">
        <app-button-group id="placeOfResidence"
                          [fieldsEnum]="PlaceOfResidence"
                          formControlName="placeOfResidence"
                          [translateKey]="'i18n.domain.administration.tariff-details.general-tab.place-of-residence-enum.'"></app-button-group>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-2 control-label">{{'i18n.domain.administration.tariff-details.general-tab.active' | translate}}</label>
      <div class="col-10 col-lg-4">
        <app-yes-no-group-button id="active"
                                 formControlName="active">
        </app-yes-no-group-button>
      </div>
    </div>
    <div class="form-row row">
      <label class="col-2 control-label">{{'i18n.domain.administration.tariff-details.general-tab.device-control-tariff' | translate}}</label>
      <div class="col-10 col-lg-4">
        <app-yes-no-group-button id="isDeviceControlTariff"
                                 formControlName="isDeviceControlTariff">
        </app-yes-no-group-button>
      </div>
    </div>
  </div>
  <div class="px-2 topLine">
    @if (!generalFormGroup.controls.isDeviceControlTariff?.value) {
      <div class="form-row row">
        <label class="col-2 control-label">{{'i18n.domain.administration.tariff-details.general-tab.max-parking-duration' | translate}}:</label>
        <div class="col-10 col-lg-4 input-wrapper">
          <app-multi-field-duration-picker [form]="generalFormGroup.controls.maxParkingDurationInMinForm"></app-multi-field-duration-picker>
          <app-error-messages [control]="generalFormGroup.controls.maxParkingDurationInMinForm"></app-error-messages>
        </div>
      </div>
    }
    <div class="form-row row">
      <label class="col-2 control-label">{{'i18n.domain.administration.tariff-details.general-tab.twenty-four-seven-tariff' | translate}}</label>
      <div class="col-10 col-lg-4">
        <app-yes-no-group-button id="isTwentyFourSevenTariff"
                                 formControlName="isTwentyFourSevenTariff">
        </app-yes-no-group-button>
      </div>
    </div>
    @if (!isTwentyFourSevenTariff) {
      <div class="form-row row">
        <label class="col-2 control-label required multiple-line-control">{{'i18n.domain.administration.tariff-details.general-tab.valid-on' | translate}}</label>
        <div class="col-10">
          <app-day-selector [form]="generalFormGroup.controls.timeWindows.controls.weekdays"></app-day-selector>
        </div>
      </div>
    }
  </div>
  @if (!isTwentyFourSevenTariff) {
    <div class="px-2 topLine">
      <div class="form-row row">
        <label class="col-2 control-label multiple-line-control">{{'i18n.domain.administration.tariff-details.general-tab.allowed-time-frame' | translate}}</label>
        <div class="col-10">
          <div class="form-group row">
            <label class="col-1 control-label required">{{'i18n.shared.time-picker.from' | translate}}:</label>
            <div class="col-3 d-flex align-items-center">
              <div [formGroup]="generalFormGroup.controls.timeWindows">
                <ejs-timepicker id="startTime"
                                name="startTime"
                                formControlName="startTime"
                                enableMask="true"
                                step="15"
                                showClearButton="true"
                                floatLabelType="Never"
                                [strictMode]="false"
                                format="HH:mm"></ejs-timepicker>
                <app-error-messages [control]="generalFormGroup.controls.timeWindows.controls.startTime"></app-error-messages>
              </div>
            </div>
            <label class="col-1 control-label required">{{'i18n.shared.time-picker.duration' | translate}}:</label>
            <div class="col-5">
              <app-multi-field-duration-picker [form]="generalFormGroup.controls.timeWindows.controls.durationForm"></app-multi-field-duration-picker>
              @if (generalFormGroup.controls.timeWindows.controls.durationForm.invalid && generalFormGroup.controls.timeWindows.controls.durationForm.touched) {
                <div class="error-message-wrapper">
                  <span class="error-message-own-line">
                    {{'i18n.domain.administration.tariff-details.general-tab.duration-error' | translate}}
                  </span>
                </div>
              }
            </div>
            @if (endTimeStr) {
              <div class="col-2 d-flex align-items-center">
                <label class="control-label">{{'i18n.shared.time-picker.to' | translate}}:</label>
                <div class="control-label single-end-time">
                  {{endTimeStr}}
                </div>
              </div>
            }
          </div>
          <div class="d-flex">
            <table class="form-text-size">
              @for (window of timeWindows; track window) {
                <tr>
                  <td>{{window.startDay}}</td>
                  <td>{{window.startTime}}</td>
                  <td class="window-delimiter">-</td>
                  <td>{{window.endDay}}</td>
                  <td>{{window.endTime}}</td>
                </tr>
              }
            </table>
            @if (showTimeWindowsError) {
              <div class="time-windows-error">
                {{'i18n.validation.timeWindowOverlap' | translate}}
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if (generalFormGroup.controls.id.value) {
    <div class="px-2 topLine" >
      <div class="form-row row">
        <label class="col-2 control-label">{{'i18n.domain.administration.tariff-details.general-tab.modified-by' | translate}}</label>
        <div class="col-10 col-lg-4 align-items-center">
            <div>{{generalFormGroup.controls.modifiedBy.value}}</div>
        </div>
      </div>
        <div class="form-row row">
          <label class="col-2 control-label">{{'i18n.domain.administration.tariff-details.general-tab.modified-on' | translate}}</label>
          <div class="col-10 col-lg-4 align-items-center">
              <div>{{generalFormGroup.controls.modifiedOn.value}}</div>
        </div>
      </div>
    </div>
  }
</div>
